import React from "react";
import { Fab, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useLocation } from "react-router-dom";

export default function WhatsAppButton({
    phone = "5531981020410",
    message = "Olá! Vim diretamente do site para obter mais informações! 😊",
}) {
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const isAdminRoute = location.pathname.startsWith("/admin");
    const isProductPage = location.pathname.startsWith("/produto/");

    if (isAdminRoute || (isMobile && isProductPage)) {
        return null;
    }

    const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(
        message
    )}`;

    return (
        <Tooltip title="Fale conosco no WhatsApp" placement="left">
            <Fab
                color="success"
                aria-label="whatsapp"
                onClick={() => window.open(whatsappLink, "_blank")}
                sx={{
                    position: "fixed",
                    bottom: { xs: 16, md: 24 },
                    right: { xs: 16, md: 24 },
                    zIndex: 9999,
                    backgroundColor: "#25D366",
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: "#1ebe5d",
                    },
                }}
            >
                <WhatsAppIcon sx={{ fontSize: 28 }} />
            </Fab>
        </Tooltip>
    );
}
